import { render, staticRenderFns } from "./NotificacaoItem.vue?vue&type=template&id=3568b6ac&scoped=true&"
import script from "./NotificacaoItem.vue?vue&type=script&lang=js&"
export * from "./NotificacaoItem.vue?vue&type=script&lang=js&"
import style0 from "./NotificacaoItem.vue?vue&type=style&index=0&id=3568b6ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3568b6ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VFlex,VIcon,VLayout,VSpacer,VTooltip})
